import { render, staticRenderFns } from "./ZarinPalTransaction.vue?vue&type=template&id=36577be0&scoped=true&"
import script from "./ZarinPalTransaction.vue?vue&type=script&lang=js&"
export * from "./ZarinPalTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36577be0",
  null
  
)

export default component.exports